import React from 'react';
import './Slider.scss'
import HK from '../../assets/images/HongKong.jpg'
import JP from '../../assets/images/Japan.jpg'
import MC from '../../assets/images/Macau.jpg'
import MA from '../../assets/images/Malaysia.jpg'

const desc= ["Japan","Hong Kong","Malaysia"]
const images = [
  "https://images.unsplash.com/photo-1559666126-84f389727b9a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1356&q=80",
  "https://images.unsplash.com/photo-1557389352-e721da78ad9f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
  "https://images.unsplash.com/photo-1553969420-fb915228af51?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1049&q=80",
  "https://images.unsplash.com/photo-1550596334-7bb40a71b6bc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
  "https://images.unsplash.com/photo-1550640964-4775934de4af?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"
];

//https://www.pexels.com/ for images
const sliderData = [
  {
    image: JP,
    heading: "Japan",
    time: "2 weeks",
    rating: "10/10",
    exp: "Clean & Tech",
    food: "Curry Katsu Chicken",
    colors:"#0088FE"
  },
  {
    image: HK,
    heading: "Hong Kong",
    time: "6+ months",
    rating: "10/10",
    exp: "Weather & Family",
    food: "Congee",
    colors: "#00C49F"
  },
  {
    image: MA,
    heading: "Malaysia",
    rating: "9/10",
    time: "2 weeks",
    exp: "Living Cost",
    food: "Hain. Chicken Rice",
    colors: "#BAD301"
  },
  {
    image: MC,
    heading: "Macau",
    time: "1 week",
    rating: "8/10",
    exp: "Gambling",
    food: "N/A",
    colors: "#CD0496"
  },
];


//add images as a list
//https://github.com/zinotrust/react-image-slider/blob/master/src/components/slider/Slider.js

const delay = 5500;

function Slideshow() {
  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }
  
  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === sliderData.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);

  return (
    <div className="slideshow">
      <div
        className="slideshowSlider"
        style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
      >
        {sliderData.map((slide, index) => (
          <div
            className="slide"
            key={index}
          >
            {/* style = {{background:slide.colors}} */}
            <img src={slide.image}/>
            <h1 className="a">{slide.heading}</h1>
            <p className="b"> Time Spent: {slide.time} <br/> Favorite Food: {slide.food}<br/> Favorite Attribute: {slide.exp} <br/> Overall Rating: {slide.rating}</p>
          </div>
        ))}
      </div>

      <div className="slideshowDots">
        {sliderData.map((_, idx) => (
          <div
            key={idx}
            className={`slideshowDot${index === idx ? " active" : ""}`}
            onClick={() => {
              setIndex(idx);
            }}
          >

          </div>
        ))}
      </div>
    </div>
  );
}

export default Slideshow
